import React from 'react';

import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';

import ReactCountryFlag from 'react-country-flag';

import { useTranslation } from 'react-i18next';
import { useResponsive } from '../hooks/useResponsive';

export const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const { isDesktop } = useResponsive();

  const getLanguageName = (code) => {
    switch (code) {
      case 'en':
        return 'English';
      case 'fr':
        return 'Français';
      default:
        return '';
    }
  };

  const getLanguageFlag = (code) => {
    switch (code) {
      case 'en':
        return 'GB';
      case 'fr':
        return 'FR';
      default:
        return '';
    }
  };

  const handleChangeLanguage = (evt) => {
    i18n.changeLanguage(evt.target.value);
  };

  const style = {
    select: {
      display: 'flex',
      height: '35px',
      minWidth: isDesktop ? '80px' : '50px',
      borderRadius: '10px',
      fontSize: '0.875rem',
      alignItems: 'center',
      gap: 10,
      '& .MuiSelect-icon': {
        color: '#FFFFFF',
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#FFFFFF',
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#FFFFFF',
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#FFFFFF',
      },
      backgroundColor: 'transparent',
    },
    menuItem: {
      display: 'flex',
      width: '100%',
      gap: 2,
    },
    labelSelect: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '1rem',
      gap: 10,
      fontWeight: 600,
      color: '#FFFFFF',
    },
    flagStyle: {
      fontSize: '1.2em',
      lineHeight: '1.2em',
    },
  };

  return (
    <FormControl fullWidth>
      <Select
        id='select-language'
        value={i18n.language}
        sx={style.select}
        variant='outlined'
        tabIndex={1}
        autoWidth
        renderValue={(selected) => (
          <div style={style.labelSelect}>
            <ReactCountryFlag
              style={style.flagStyle}
              countryCode={getLanguageFlag(selected)}
            />
            {isDesktop && getLanguageName(selected)}
          </div>
        )}
        onChange={handleChangeLanguage}
      >
        <MenuItem sx={style.menuItem} value='fr'>
          <ReactCountryFlag countryCode='FR' />
          Français
        </MenuItem>
        <MenuItem sx={style.menuItem} value='en'>
          <ReactCountryFlag countryCode='GB' />
          English
        </MenuItem>
      </Select>
    </FormControl>
  );
};
